module.exports = __webpack_public_path__ + "static/VIC-f8930ceef2ba658f9f3879c298a2e968.svg";